// extracted by mini-css-extract-plugin
export default {"is-editor-empty":"RichTextEditor_is-editor-empty__SQQBT","tiptap":"RichTextEditor_tiptap__5roLg"};